import Javascript from '../assets/skills/javascript.png'
import React from '../assets/skills/react.png'
import Redux from '../assets/skills/redux.png'
import CSS from '../assets/skills/css3.png'
import HTML from '../assets/skills/html-5.png'
import Firebase from '../assets/skills/firebase.png'
import Cordova from '../assets/skills/cordova.png'
import Postgresql from '../assets/skills/postgresql.png'
import Font_Awesome from '../assets/skills/Font_Awesome.png'
import Mongodb from '../assets/skills/mongodb.png'
import material_ui from '../assets/skills/material-ui.png'
import Jira from '../assets/skills/Jira.png'
import Trello from '../assets/skills/trello.png'
import Bootstrap from '../assets/skills/bootstrap.png'
import Maven from '../assets/skills/maven.jpg'
import Angular from '../assets/skills/angular.png'
import Java from '../assets/skills/java.png'
import Scrum from '../assets/skills/Agile Scrum.png'
import Swagger from '../assets/skills/swagger.png'
import SonarQube from '../assets/skills/sonarCube.svg'
import Git from '../assets/skills/git.png'
import Rest_Api from '../assets/skills/Rest Api.png'
import Hibernate from '../assets/skills/hibernate.jpg'
import Ant_Design from '../assets/skills/Ant design.svg'
import Spring from '../assets/skills/spring.png'
import Websocket from '../assets/skills/websocket.png'
import PrimeNG from '../assets/skills/primeng.png'
import Google_Map_Api from '../assets/skills/google-maps.png'
import Jquery from '../assets/skills/jquery.png'
import Google_Auth from '../assets/skills/google-authentication.png'
import Facebook_auth from '../assets/skills/facebook.png'
import TypeScript from '../assets/skills/typescript.png'
import MySQL from '../assets/skills/mysql.png'
import NoSqlUnit from '../assets/skills/nosqlunit.png'
import H2 from '../assets/skills/h2.png'
import Jenkins from '../assets/skills/jenkins.png'
import Tomcat from '../assets/skills/tomcat.png'
import SQL from '../assets/skills/sql.png'
import JPA from '../assets/skills/spring-data-jpa.png'
import PayPal from '../assets/skills/paypal.png'
import Axios  from '../assets/skills/Axios.png'
import POSTMAN  from '../assets/skills/postman.png'
import Word  from '../assets/skills/word.png'
import Excel  from '../assets/skills/excel.png'
import Powerpoint from '../assets/skills/powerpoint.png'
import SpringSecurity from '../assets/skills/springsecurity.png'
import SpringbootAdmin from '../assets/skills/spring-boot-admin.png' 
import springCloudGateway from '../assets/skills/gateway-spring-cloud.png' 
import netflixZuul from '../assets/skills/netflix-zuul.png'
import docker from '../assets/skills/docker.png'

const mySkills = [
    {
        Type: "Languages",
        data: [
            {
                id: 1,
                iconSkill: Javascript,
                nameSkill: "Javascript",

            },

            {
                id: 4,
                iconSkill: TypeScript,
                nameSkill: "TypeScript",

            },

            {
                id: 21,
                iconSkill: Java,
                nameSkill: "Java",

            },
            {
                id: 14,
                iconSkill: Jquery,
                nameSkill: "Jquery",

            },
            
            {
                id: 56,
                iconSkill: SQL,
                nameSkill: "SQL",

            }

        ]
    },
  
    {
        Type: "Front-End",
        data: [
            {
                id: 2,
                iconSkill: React,
                nameSkill: "React",

            },
            {
                id: 3,
                iconSkill: Redux,
                nameSkill: "Redux JS",

            },

            {
                id: 32,
                iconSkill: Angular,
                nameSkill: "Angular",

            },
            {
                id: 7,
                iconSkill: CSS,
                nameSkill: "CSS 3",

            },
            {
                id: 8,
                iconSkill: HTML,
                nameSkill: "HTML 5",

            },
            {
                id: 22,
                iconSkill: Font_Awesome,
                nameSkill: "Font Awesome",

            },
            {
                id: 23,
                iconSkill: PrimeNG,
                nameSkill: "PrimeNG",

            },
            {
                id: 24,
                iconSkill: material_ui,
                nameSkill: "Material UI",

            },
            {
                id: 25,
                iconSkill: Bootstrap,
                nameSkill: "Bootstrap",

            },
            {
                id: 26,
                iconSkill: Ant_Design,
                nameSkill: "Ant Design",

            },
            {
                id: 13,
                iconSkill: Google_Map_Api,
                nameSkill: "Google Map Api",

            },
            {
                id: 6,
                iconSkill: Facebook_auth,
                nameSkill: "Facebook Authenticator",

            },
                        
            {
                id: 9,
                iconSkill: Google_Auth,
                nameSkill: "Google Authenticator",

            },
            {
                id: 59,
                iconSkill: PayPal,
                nameSkill: "PayPal API",

            }
            ,
            {
                id: 77,
                iconSkill: Axios,
                nameSkill: "Axios",

            }

        ]
    },

    {
        Type: "Back-End",
        data: [

            {
                id: 27,
                iconSkill: Spring,
                nameSkill: "Spring Framework",

            },

            {
                id: 30,
                iconSkill: Rest_Api,
                nameSkill: "Rest Api",

            },
            {
                id: 98,
                iconSkill: SpringSecurity,
                nameSkill: "Spring Security",

            },
            {
                id: 100,
                iconSkill: SpringbootAdmin,
                nameSkill: "Spring Boot Admin",

            },
            {
                id: 66,
                iconSkill: JPA,
                nameSkill: "Spring Data JPA",

            },
            {
                id: 101,
                iconSkill: springCloudGateway,
                nameSkill: "Spring Cloud",

            },
            {
                id: 102,
                iconSkill: netflixZuul,
                nameSkill: "Netflix Zuul",

            },
                        
            {
                id: 28,
                iconSkill: Swagger,
                nameSkill: "Swagger",

            },
            {
                id: 10,
                iconSkill: Websocket,
                nameSkill: "Websocket",

            },
            
            {
                id: 11,
                iconSkill: Hibernate,
                nameSkill: "Hibernate",

            },
            {
                id: 36,
                iconSkill: Firebase,
                nameSkill: "Firebase",

            },
            {
                id: 80,
                iconSkill: POSTMAN,
                nameSkill: "Postman",

            }
        ]
    },

    {
        Type: "DataBase",
        data: [

            {
                id: 33,
                iconSkill: MySQL,
                nameSkill: "MySQL",

            },
            {
                id: 34,
                iconSkill: NoSqlUnit,
                nameSkill: "NoSqlUnit",

            },
            {
                id: 35,
                iconSkill: H2,
                nameSkill: "H2",

            },
            {
                id: 16,
                iconSkill: Postgresql,
                nameSkill: "Postgresql",

            },
            {
                id: 17,
                iconSkill: Mongodb,
                nameSkill: "Mongodb",

            },

        ]
    },

    {
        Type: "Mobile",
        data: [
            {
                id: 15,
                iconSkill: Cordova,
                nameSkill: "Cordova",

            },
            {
                id: 5,
                iconSkill: Firebase,
                nameSkill: "Firebase",

            },
        ]
    },
    {
        Type: "Continuous Integration",
        data: [

            {
                id: 29,
                iconSkill: SonarQube,
                nameSkill: "SonarQube",

            },
            {
                id: 31,
                iconSkill: Maven,
                nameSkill: "Maven",

            },

            {
                id: 37,
                iconSkill: Jenkins,
                nameSkill: "Jenkins",

            },
            {
                id: 12,
                iconSkill: Git,
                nameSkill: "Git",

            },
            {
                id: 112,
                iconSkill: docker,
                nameSkill: "Docker",

            }
        ]
    },
    {
        Type: "Agile",
        data: [

            {
                id: 18,
                iconSkill: Jira,
                nameSkill: "Jira",

            },
            {
                id: 19,
                iconSkill: Trello,
                nameSkill: "Trello",

            },
            {
                id: 20,
                iconSkill: Scrum,
                nameSkill: "Scrum",

            }

        ]
    },
    {
        Type: "Servers",
        data: [

            {
                id: 55,
                iconSkill: Tomcat,
                nameSkill: "Apache Tomcat",

            },
            

        ]
    },
    {
        Type: "Office software",
        data: [

            {
                id: 81,
                iconSkill: Excel,
                nameSkill: "Excel",

            },
            {
                id: 82,
                iconSkill: Word,
                nameSkill: "Word",

            },
            {
                id: 83,
                iconSkill: Powerpoint,
                nameSkill: "PowerPoint",

            },
            

        ]
    }


]


export default mySkills